export enum TachoTypeData {
    Driving = 1,
    Work = 2,
    Rest = 3,
    Availability = 4,
}
